











import Vue from "vue";
import { SearchResponseDocument } from "search-api-client/lib/models";
export default Vue.extend({
  name: "ResultProject",
  props: {
    result: {
      type: Object as () => SearchResponseDocument,
      required: true,
      default: []
    }
  }
});
